export default {
  computed: {
    severType(){
      let {severType} = this.$route.params
      return severType
    },
    isFina(){
      let path = this.$route.path
      return path.includes('/fina/')
    },
    btn_text(){
      let text = ''
      if(this.customerId && this.selectCustomerData){
        text = this.selectCustomerData.isrd_nm.trim() == ''? 'Unnamed Account' : this.selectCustomerData.isrd_nm
      }else{
        text = 'Select Customer'
      }
      if(text.length > 25){
        text = text.substr(0, 25) + '...'
      }
      return text
    },
    btn_refer_text(){
      let text = ''
      if(this.referCustomerId && this.selectReferCustomerData){
        text = this.selectReferCustomerData.isrd_nm.trim() == ''? 'Unnamed Account' : this.selectReferCustomerData.isrd_nm
      }else{
        text = 'Select Referrer'
      }
      if(text.length > 25){
        text = text.substr(0, 25) + '...'
      }
      return text
    },
  }
}
